import React, { useState } from "react";
import {
    getExtract
} from "../service/api";
import { convertToArray, downloadCsvFile } from '../Utils/utils';
import { makeStyles } from "@material-ui/core/styles";
import AspModal from '../components/AspModal/AspModal';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles({
    linkText: {
        cursor: 'pointer',
        color: 'blue'
    }
  });

export default function BusinessSystemExtractDocument(id) {
    const classes = useStyles();
    const [ extractError, setExtractError ] = useState(false);
    const getPurchaseReceiptData = async () => {
        const body = {
            "extractType": "ID",
            "extractValue": id?.id,
            "extractScope": "TENANT"
        }
        const ExtractData = await getExtract(body);
        if(ExtractData?.data !== 'FALSE') {
            var sampleArr = convertToArray(ExtractData?.data);
            downloadCsvFile(sampleArr, 'exactFile.csv', 'text/csv;charset=utf-8;')
        } else {
            setExtractError(true)
        }
    }

    const errorConfirmedHandler = () => {
        setExtractError(false)
    }

    return (
        <>
        {extractError && <AspModal
                        show={extractError}
                        okButtonHandler={() => errorConfirmedHandler()}
                        color="#CC0000"
                        size="7x"
                        icon={faTimesCircle}
                        displayText1="We are experiencing technical difficulties."
                        displayText2="Please try again later."
                        buttonText1="OK">
                        {'We are experiencing technical difficulties.'}
                    </AspModal>}
        <span key={id?.id} onClick={() => getPurchaseReceiptData()} className={classes.linkText}>{id?.label}</span>
        </>
    );
}
